export default __webpack_public_path__ + "static/media/instagram.290ca1e8.svg";